import { useStore } from 'vuex'
import { computed } from 'vue'

export default function useUtils() {
  const store = useStore()
  const languageInfoList = computed(() => store.state.user.languageInfoList)
  const industryTreeList = computed(() => store.state.user.industryTreeList)

  const getLanguageName = (id) => {
    if (!languageInfoList.value) return '' // 避免接口返回null造成下面find函数报错，前端页面crash掉（2021.8.5 dev环境发生过一次）
    const item = languageInfoList.value.find((res) => res.languageId == id)
    if (item) {
      return item.languageName
    } else {
      return ''
    }
  }

  const getIndustryName = (id) => {
    if (!industryTreeList.value) return ''
    const item = industryTreeList.value.find(
      (res) => res.industryId == id || res.oldIndustryId == id
    )
    if (item) {
      return item.industryName
    } else {
      return ''
    }
  }

  // 是否是electron环境
  const isElectronHandler = () => {
    var userAgent = navigator.userAgent.toLowerCase()
    return userAgent.indexOf(' electron/') > -1
  }

  // 是否含有electronApi注入
  const hasElectronApiHandler = () => {
    var hasElectronApi = window.electronApi ? true : false
    return hasElectronApi
  }

  // 是否含有electronApi  openWordCount方法 字数统计
  const hasOpenWordCountApiHandler = () => {
    if (!window.electronApi) {
      return false
    }
    if (window.electronApi.hasOwnProperty('openWordCount')) {
      return true
    }
    return false
  }

  // 是否含有electronApi  openSplitAndMerge方法 文件拆分合并
  const hasOpenSplitAndMergeApiHandler = () => {
    if (!window.electronApi) {
      return false
    }
    if (window.electronApi.hasOwnProperty('openSplitAndMerge')) {
      return true
    }
    return false
  }

  // 是否含有electronApi  openToolChangeExcel方法 工具转换Excel
  const hasOpenToolChangeExcelApiHandler = () => {
    if (!window.electronApi) {
      return false
    }
    if (window.electronApi.hasOwnProperty('openToolChangeExcel')) {
      return true
    }
    return false
  }

  // 千分符
  const thousandBitSeparator = (number) => {
    if (number === '' || number === null || number === undefined) return ''
    let separatingSymbol = ',' //分隔符
    var numpart = String(number).split('.')
    for (let i = 0; i < numpart.length; i++) {
      numpart[i] = numpart[i].replace(
        new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'),
        `$1${separatingSymbol || ''}`
      )
    }
    return numpart.join('.')
  }

  // 判断当前环境
  const getCurrentEvn = () => {
    const origin = window.location.origin
    // 通过域名格式来判定环境
    const env = {
      isDev: /-dev|(\.dev)/.test(origin),
      isQa: /-qa|(\.qa)/.test(origin),
      isRelease: /-release|(\.release)/.test(origin),
      isLocal: /-localhost|(\.localhost)/.test(origin),
    }
    if (env.isLocal) {
      return 'dev'
    }
    if (env.isDev) {
      return 'dev'
    }
    if (env.isQa) {
      return 'qa'
    }
    if (env.isRelease) {
      return 'release'
    }
    return 'pro'
  }

  const isQianKunFunc = () => {
    return window.__POWERED_BY_QIANKUN__ ? true : false
  }

  const isMobileFunc = () => {
    const flag = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
    return flag
  }

  return {
    getLanguageName,
    getIndustryName,
    isElectronHandler,
    hasElectronApiHandler,
    hasOpenWordCountApiHandler,
    hasOpenSplitAndMergeApiHandler,
    hasOpenToolChangeExcelApiHandler,
    thousandBitSeparator,
    getCurrentEvn,
    isQianKunFunc,
    isMobileFunc,
  }
}
